import { useRef, useState } from 'react';

import { List, Modal } from 'antd';
import Button from 'app/components/Button';
import Panel from 'app/components/Layout/Panel';
import classes from './Style.module.scss';
import { Formik, useFormikContext } from 'formik';
import Edit from './Edit';
import POItems from '../../../InspectionCriteria/EnhancedPoItem';
import { pick } from 'lodash';

const Report = (props) => {
  const formikRef = useRef(null);
  const { values, setValues } = useFormikContext();

  const { inspectionRequirement }: any = values;
  const [edit, setEdit] = useState(false);
  const { value } = props;
  return (
    <Panel
      className={classes.report}
      title="B) Report Detail"
      extra={
        <Button
          type="link"
          onClick={() => {
            setEdit(true);
          }}
        >
          Edit
        </Button>
      }
    >
      <POItems poItems={value} className={classes.list} hideTemplate />

      <Modal
        open={edit}
        destroyOnClose
        title="Report Detail"
        width="80%"
        cancelButtonProps={{ hidden: true }}
        onOk={() => {
          formikRef.current.submitForm();
          setEdit(false);
        }}
        onCancel={() => {
          setEdit(false);
        }}
        okText="Confirm"
        bodyStyle={{
          maxHeight: 650,
          overflowY: 'auto'
        }}
      >
        <Formik
          initialValues={values}
          enableReinitialize
          onSubmit={(values) => {
            setValues(values);
          }}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            return (
              <Edit
                aqlFromJobLevel={pick(inspectionRequirement, [
                  'criticalLevel',
                  'criticalMajorLevel',
                  'criticalMinorLevel'
                ])}
              />
            );
          }}
        </Formik>
      </Modal>
    </Panel>
  );
};

export default Report;
